
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'BurnDeep',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Trauma/BurnDeep.vue